import React, { Component } from 'react';
import { connect } from 'react-redux';
import { push as Push } from 'redux-first-history';
import { DomainsAdvanced as SettingsModule } from '@dev/ee-modules';

import { ApplicationState as State } from '@/store';
import { SettingsPaths } from '@/services/dictionaries/Paths';
import { SetValidSenderDomains } from '@/store/account/actions';

import { DomainsProps as Props } from './DomainsInterface';

/* eslint-disable max-lines-per-function */
const mapState = (state: State, ownProps: Props): Props => ({
    ...ownProps,
    account: state.account,
    browser: state.browser,
});
const dispatchProps = {
    Push,
    SetValidSenderDomains,
};
interface DispatchProps {
    Push(url: string): void;
    SetValidSenderDomains(validSenderDomain?: boolean): any;
}

type ExtendedProps = Props & DispatchProps;

class DomainsAdvanced extends Component<ExtendedProps> {
    render(): JSX.Element {
        return <SettingsModule {...this.props} paths={SettingsPaths} />;
    }
}

export default connect<Props, DispatchProps>(mapState, dispatchProps)(DomainsAdvanced);
